// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimPharmacyClaimModel {
    static getAttributeTypeMap() {
        return ClaimPharmacyClaimModel.attributeTypeMap;
    }
}
ClaimPharmacyClaimModel.discriminator = undefined;
ClaimPharmacyClaimModel.additionalProperties = false;
ClaimPharmacyClaimModel.attributeTypeMap = [
    {
        "name": "claimId",
        "baseName": "claimId",
        "type": "number"
    },
    {
        "name": "claimGroupId",
        "baseName": "claimGroupId",
        "type": "number"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "updatedBy",
        "baseName": "updatedBy",
        "type": "number"
    },
    {
        "name": "promotionGroupNumber",
        "baseName": "promotionGroupNumber",
        "type": "string"
    },
    {
        "name": "isTestBatch",
        "baseName": "isTestBatch",
        "type": "boolean"
    },
    {
        "name": "paymentMethodTypeId",
        "baseName": "paymentMethodTypeId",
        "type": "number"
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": "Array<ClaimConditionModel>"
    },
    {
        "name": "initialOutOfPocketAmount",
        "baseName": "initialOutOfPocketAmount",
        "type": "number"
    },
    {
        "name": "ndcId",
        "baseName": "ndcId",
        "type": "number"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "drugName",
        "baseName": "drugName",
        "type": "string"
    },
    {
        "name": "pharmacyNabpNumber",
        "baseName": "pharmacyNabpNumber",
        "type": "string"
    },
    {
        "name": "pharmacyNpi",
        "baseName": "pharmacyNpi",
        "type": "string"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "pharmacyAddressOne",
        "baseName": "pharmacyAddressOne",
        "type": "string"
    },
    {
        "name": "pharmacyAddressTwo",
        "baseName": "pharmacyAddressTwo",
        "type": "string"
    },
    {
        "name": "pharmacyCity",
        "baseName": "pharmacyCity",
        "type": "string"
    },
    {
        "name": "pharmacyState",
        "baseName": "pharmacyState",
        "type": "string"
    },
    {
        "name": "pharmacyZip",
        "baseName": "pharmacyZip",
        "type": "string"
    },
    {
        "name": "pharmacyChainNumber",
        "baseName": "pharmacyChainNumber",
        "type": "string"
    },
    {
        "name": "pharmacyChainName",
        "baseName": "pharmacyChainName",
        "type": "string"
    },
    {
        "name": "rxNumber",
        "baseName": "rxNumber",
        "type": "string"
    },
    {
        "name": "serviceDate",
        "baseName": "serviceDate",
        "type": "Date"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "groupName",
        "baseName": "groupName",
        "type": "string"
    },
    {
        "name": "quantityDispensed",
        "baseName": "quantityDispensed",
        "type": "number"
    },
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "number"
    },
    {
        "name": "dispensedAsWrittenCode",
        "baseName": "dispensedAsWrittenCode",
        "type": "string"
    },
    {
        "name": "isNewRefill",
        "baseName": "isNewRefill",
        "type": "boolean"
    },
    {
        "name": "prescriberFirstName",
        "baseName": "prescriberFirstName",
        "type": "string"
    },
    {
        "name": "prescriberLastName",
        "baseName": "prescriberLastName",
        "type": "string"
    },
    {
        "name": "submittedUsualAndCustomaryCost",
        "baseName": "submittedUsualAndCustomaryCost",
        "type": "number"
    },
    {
        "name": "submittedIngredientCost",
        "baseName": "submittedIngredientCost",
        "type": "number"
    },
    {
        "name": "submittedDispensingFee",
        "baseName": "submittedDispensingFee",
        "type": "number"
    },
    {
        "name": "submittedSalesTax",
        "baseName": "submittedSalesTax",
        "type": "number"
    },
    {
        "name": "submittedGrossAmount",
        "baseName": "submittedGrossAmount",
        "type": "number"
    },
    {
        "name": "prescriberDea",
        "baseName": "prescriberDea",
        "type": "string"
    },
    {
        "name": "prescriberNpi",
        "baseName": "prescriberNpi",
        "type": "string"
    },
    {
        "name": "submittedCopayAmount",
        "baseName": "submittedCopayAmount",
        "type": "number"
    },
    {
        "name": "calculatedAverageWholesalePrice",
        "baseName": "calculatedAverageWholesalePrice",
        "type": "number"
    },
    {
        "name": "rxWrittenDate",
        "baseName": "rxWrittenDate",
        "type": "Date"
    },
    {
        "name": "otherCoverageCode",
        "baseName": "otherCoverageCode",
        "type": "string"
    },
    {
        "name": "otherPayerAmount",
        "baseName": "otherPayerAmount",
        "type": "number"
    },
    {
        "name": "isRefillAuthorized",
        "baseName": "isRefillAuthorized",
        "type": "boolean"
    },
    {
        "name": "refillNumber",
        "baseName": "refillNumber",
        "type": "number"
    },
    {
        "name": "priorAuthorizationNumber",
        "baseName": "priorAuthorizationNumber",
        "type": "string"
    },
    {
        "name": "cobIds",
        "baseName": "cobIds",
        "type": "Array<number>"
    },
    {
        "name": "claimReceivedDate",
        "baseName": "claimReceivedDate",
        "type": "Date"
    },
    {
        "name": "parentClaimId",
        "baseName": "parentClaimId",
        "type": "number"
    },
    {
        "name": "claimTypeId",
        "baseName": "claimTypeId",
        "type": "number"
    },
    {
        "name": "patientLastName",
        "baseName": "patientLastName",
        "type": "string"
    },
    {
        "name": "patientFirstName",
        "baseName": "patientFirstName",
        "type": "string"
    },
    {
        "name": "patientDateOfBirth",
        "baseName": "patientDateOfBirth",
        "type": "Date"
    },
    {
        "name": "patientSex",
        "baseName": "patientSex",
        "type": "string"
    },
    {
        "name": "patientAddress",
        "baseName": "patientAddress",
        "type": "string"
    },
    {
        "name": "patientCity",
        "baseName": "patientCity",
        "type": "string"
    },
    {
        "name": "patientState",
        "baseName": "patientState",
        "type": "string"
    },
    {
        "name": "patientZip",
        "baseName": "patientZip",
        "type": "string"
    },
    {
        "name": "patientPhoneNumber",
        "baseName": "patientPhoneNumber",
        "type": "string"
    },
    {
        "name": "patientRelationshipTypeId",
        "baseName": "patientRelationshipTypeId",
        "type": "number"
    },
    {
        "name": "patientExternalReferences",
        "baseName": "patientExternalReferences",
        "type": "Array<ClaimExternalReferenceModel>"
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "dateProcessed",
        "baseName": "dateProcessed",
        "type": "Date"
    },
    {
        "name": "processedBy",
        "baseName": "processedBy",
        "type": "number"
    },
    {
        "name": "transactionBatchNumber",
        "baseName": "transactionBatchNumber",
        "type": "string"
    },
    {
        "name": "transactionNumber",
        "baseName": "transactionNumber",
        "type": "string"
    },
    {
        "name": "processorSponsorNumber",
        "baseName": "processorSponsorNumber",
        "type": "string"
    },
    {
        "name": "processorGroupNumber",
        "baseName": "processorGroupNumber",
        "type": "string"
    },
    {
        "name": "parClientNumber",
        "baseName": "parClientNumber",
        "type": "string"
    },
    {
        "name": "locationNumber",
        "baseName": "locationNumber",
        "type": "string"
    },
    {
        "name": "externalStatus",
        "baseName": "externalStatus",
        "type": "string"
    },
    {
        "name": "exceptionTypeIds",
        "baseName": "exceptionTypeIds",
        "type": "Array<number>"
    },
    {
        "name": "overrideTypeIds",
        "baseName": "overrideTypeIds",
        "type": "Array<number>"
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": "Array<ClaimExternalReferenceModel>"
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "claimStatusId",
        "baseName": "claimStatusId",
        "type": "number"
    },
    {
        "name": "requestedPaymentMethodTypeId",
        "baseName": "requestedPaymentMethodTypeId",
        "type": "number"
    },
    {
        "name": "benefitPaid",
        "baseName": "benefitPaid",
        "type": "number"
    },
    {
        "name": "remainingCost",
        "baseName": "remainingCost",
        "type": "number"
    },
    {
        "name": "rejectTypeIds",
        "baseName": "rejectTypeIds",
        "type": "Array<number>"
    },
];
//# sourceMappingURL=claimPharmacyClaimModel.js.map